<div class="row">
    <div class="col-xs-12">
        <div class="box">
            <div class="card card--b2c--box pb-1">
                <div class="card--b2c--box__header">
                    <div class="card--b2c--box__header--info">
                        <div class="card--b2c--box__header__title">
                            {{ 'Metrics' | translate }}
                        </div>
                    </div>
                    <div class="text-xs-right">
                    </div>
                </div>
            </div>
            <ng-container *ngIf="chartGenerated">
                <div class="card card--box--dashboard__item__block mental-check">
                    <div class="row">
                        <div class="col-sm-3 col-xs-12 mental-check__col" *ngFor="let chart of chartTypes">
                            <highcharts-chart
                                    [Highcharts]="Highcharts"
                                    [options]="chart['options']"
                                    class="metrics-chart"
                                    style="width: 100%; height: 400px; display: block;"
                            ></highcharts-chart>
                        </div>

                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<div class="row" *ngIf="services">
    <div class="col-xs-12">
        <div class="box">
            <div class="b2c-table--grid metrics">
                <div class="b2c-table--grid__body coupons__body">
                    <div class="row">
                        <!--table headers-->
                        <div class="col-xs-12 coupons__column">
                            <div class="row">
                                <div *ngFor="let column of tableColumns" class="{{ column[2] }}"
                                     (click)="sortData(column[0]);"
                                     title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span>
                                    {{ column[1] | translate }}
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--table cells-->
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-4">
                                    <span  class="col col--col-xs-4">
                                        <span> {{ 'Starter' | translate}} </span>
                                    </span>
                                </div>
                                <div class="col-xs-4">
                                    <span  class="col col--col-xs-4">
                                        <span> {{ data.starter_paid }} </span>
                                    </span>
                                </div>
                                <div class="col-xs-4">
                                    <span  class="col col--col-xs-4">
                                        <span> {{ data.starter_completed }} </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="row">
                                <div class="col-xs-4">
                                    <span  class="col col--col-xs-4">
                                        <span> {{ 'First Call Package (Appointment)' | translate }} </span>
                                    </span>
                                </div>
                                <div class="col-xs-4">
                                    <span  class="col col--col-xs-4">
                                        <span> {{ data.appointment_paid }} </span>
                                    </span>
                                </div>
                                <div class="col-xs-4">
                                    <span  class="col col--col-xs-4">
                                        <span> {{ data.appointment_completed }} </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>